//Get Region
export const GET_REGION = "GET_REGION";

//Insert Region
export const INSERT_REGION = "INSERT_REGION";

//Update Region
export const UPDATE_REGION = "UPDATE_REGION";

//Delete Region
export const DELETE_REGION = "DELETE_REGION";

//Insert Open Dialog
export const OPEN_REGION_DIALOG = "OPEN_REGION_DIALOG";

//Close Dialog
export const CLOSE_DIALOG = "CLOSE_DIALOG";

//toast
export const OPEN_REGION_TOAST = "OPEN_REGION_TOAST";
export const CLOSE_REGION_TOAST = "CLOSE_REGION_TOAST";
